import { Navigate, useRoutes } from 'react-router-dom';

import { systemDashboardRoutes } from 'src/routes/sections/system-dashboard';

import { PATH_AFTER_LOGIN } from 'src/config-global';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { setupRoutes } from './setup';
import { externalRoutes } from './external';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Setup routes
    ...setupRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    ...systemDashboardRoutes,

    // Main routes
    ...mainRoutes,

    ...externalRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
